import hero from '../../../../assets/images/marketing_Agent/hero.webp';

const highlights = [
  'Open to professionals from different backgrounds',
  'Ranks earned through your own efforts',
  'Choose the business you represent',
];

export default function Hero() {
  return (
    <section className="hero marketing-agent-hero text-white">
      <div className="container marketing-agent-hero-container">
        <div className="row align-items-center g-4">
          <div className="col-lg-7">
            <h1 className="marketing-agent-hero-title">
              Become an
              <br />
              Official <span>SELECTEZI</span>
              <br />
              <span>Marketing Agent</span>
            </h1>
            <button type="button" className="marketing-agent-hero-time">
              <span>Become an agent in</span>
              <strong>5 minutes</strong>
            </button>
            <p className="marketing-agent-hero-description">
              Any unemployed person, specialist, or experienced professional can become an official SELECTEZI marketing agent by fulfilling the requirements.
            </p>
            <p className="marketing-agent-hero-description marketing-agent-hero-emphasis">
              <strong>Earn ranks based on your own efforts</strong> and become a popular sales and marketing agent for any business of your choice.
            </p>
          </div>
          <div className="col-lg-5">
            <img
              src={hero}
              alt="A marketing agent connecting with business owners through a growing professional network"
              className="img-fluid rounded-3 w-100 marketing-agent-hero-image"
            />
          </div>
        </div>
        <div className="row g-0 mt-4 marketing-agent-hero-highlights">
          {highlights.map((highlight) => (
            <div key={highlight} className="col-12 col-md-4 marketing-agent-hero-highlight">
              <i className="bi bi-star-fill text-gold" aria-hidden="true" />
              <span>{highlight}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
